<template>
  <div class="zone">
    <div class="zone-top">
      <div class="flex-nav">
        <div
          class="nav-txt"
          :class="active === '1' ? 'cur' : ''"
          @click="handleClick('1')"
        >
          待报名
          <img
            src="@/assets/images/zone/img2.png"
            v-if="active === '1'"
            class="icon1"
            alt=""
          />
        </div>
        <div
          class="nav-txt"
          :class="active === '2' ? 'cur' : ''"
          @click="handleClick('2')"
        >
          已报名
          <img
            src="@/assets/images/zone/img2.png"
            v-if="active === '2'"
            class="icon1"
            alt=""
          />
        </div>
        <div
          class="nav-txt"
          :class="active === '3' ? 'cur' : ''"
          @click="handleClick('3')"
        >
          已结营
          <img
            src="@/assets/images/zone/img2.png"
            v-if="active === '3'"
            class="icon1"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="list" :class="active === '1' ? 'patop' : ''">
      <div class="search_box" v-if="active === '1'">
        <div class="search_group">
          <div
            :class="['btn', check === '' ? 'check' : '']"
            @click="handleCheck('')"
          >
            全部
          </div>
          <div
            :class="['btn', check === '0' ? 'check' : '']"
            @click="handleCheck('0')"
          >
            免费
          </div>
          <div
            :class="['btn', check === '1' ? 'check' : '']"
            @click="handleCheck('1')"
          >
            解锁
          </div>
        </div>
      </div>
      <div class="div-infos" v-if="active === '3' && showOver">
        <img src="@/assets/images/training/img(54).png" class="icon-tips" alt="">
        <div class="infos-txt">
          已结营的训练营，如有需要可以点击<span class="txt-col">进入训练营</span>，查看该训练营相关<span class="txt-col">历史课程</span>。
        </div>
        <div class="div-close" @click="handleSubmitRemind('CampEndList')">
          不再显示
          <img src="@/assets/images/training/img(55).png" class="icon-close" alt="">
        </div>
      </div>
      <van-list
        v-if="!isNone"
        v-model="pageObj.loading"
        :finished="pageObj && pageObj.finished"
        finished-text="没有更多了"
        @load="handleGetPostList"
      >
        <div class="item" v-for="item in postListArr" :key="item.id" @click="handleClickTO(item)">
          <div class="item_content" @click.stop="handleClickToCover(item)">
            <div class="info">
              <div class="name">{{ item && item.title }}</div>
              <div class="tips">{{ item && item.intro }}</div>
              <div class="lock" v-if="active === '1' || (active === '3' && !item.joinSign)">
                <!-- <img
                  v-show="item && item.unlockMethod"
                  class="img"
                  src="../../assets/train/lock.png"
                  alt=""
                /> -->
                <template v-if="item.unlockMethod && `${item.unlockSign}` === '0'">
                  <img class="img" src="../../assets/train/lock.png">
                  <span>{{ `可使用${item.unlockCost}积分解锁` }}</span>
                </template>
                <span v-else-if="item.unlockMethod">积分已解锁</span>
                <span v-else>免费</span>
              </div>
              <div class="rate" v-if="active === '3' && item.feedbackSign">
                <van-rate
                  v-model="item.feedbackInfo.score"
                  allow-half
                  :size="16"
                  readonly
                  void-icon="star"
                  void-color="#eee"
                    color="#EB1700"
                />
                <span v-if="item.feedbackInfo.score >= 0">{{ item.feedbackInfo.score * 2 }}分</span>
              </div>
              <div class="tips tips2">开始时间:{{ item.startTimeTxt2 }}</div>
              <div class="tips tips2">结束时间:{{ item.endTimeTxt2 }}</div>
            </div>
            <div class="img_page" v-if="item.cover">
              <img class="img" :src="item.cover.url" alt="">
              <div class="img-txt">已报名{{ item.campUserNum }}人</div>
            </div>
          </div>
          <div class="item_btn" v-if="active === '1'">
            {{ item.startTimeTxt ? `${item.startTimeTxt}开营` : '已开营' }}/马上报名
          </div>
          <div class="item_btn" v-if="active === '2'">
            {{ item.startTimeSignTxt ? `距开营${item.startTimeSignTxt}` : '学习中' }}
          </div>
          <div class="item_btn_group" v-if="active === '3' && item.joinSign">
            <div class="item_btn item_btn_light" @click.stop="handleClickTO(item)">
              {{ item.feedbackSign ? '查看评价' : '评价' }}
            </div>
            <div class="item_btn" @click.stop="handleClickToCover(item, true)">
              观看回放
            </div>
          </div>
          <div class="item_btn isEnd" v-if="active === '3' && !item.joinSign">
            未报名
          </div>
        </div>
      </van-list>
      <div class="empty-block" v-else>
        <img
          src="@/assets/images/zone/img18.png"
          class="empty-img"
          alt=""
        />
        <div class="empty-txt" v-if="active === '1'">
          目前没有待报名的训练营,<br/>
          您可查看"往期训练营"中的内容
          <span class="btn-tips" @click.stop="handleClick('3')">往期训练营 > </span>
        </div>
        <div class="empty-txt" v-if="active === '2'">还没有报名训练营,快去报名吧~</div>
        <!-- <div class="empty-txt" v-else>暂无内容</div> -->
      </div>
      <TrainModel ref="trainModel" :showCourseEvaluate.sync="showCourseEvaluate"/>
      <div class="div-mask" v-if="showHome">
        <div class="div-mask-bg"></div>
        <div class="div-mask-con">
          <div class="title">
            <div class="title-txt">温馨提示</div>
          </div>
          <div class="content">
            欢迎您加入iEP训练营，这里汇聚了行业资深专家，为您精心设计了一系列实用电生理学习课程。您<span class="txt-col">可以根据自己的兴趣和需求，自由选择并预约课程。</span>课程期间，我们<span
            class="txt-col">提供内容小测试，助您巩固学习成果。</span><br>
            我们提供两种模式的训练营：<span class="txt-col">免费和积分解锁的收费课程。</span>积分获取详情，请访问"我的—积分规则"。请注意，训练营结束后，课程内容将转为EP公开课，我们建议您在开营期间充分利用资源，每天仅需10分钟，让电生理学习变得更加高效和轻松。立即开始您的学习之旅吧！<br>
            训练营结束后，希望您<span class="txt-col">写下</span>最真实的<span class="txt-col">建议给我们反馈</span>，我们会基于您的建议及时调整学习内容！
          </div>
          <div class="mask-submit-btn" @click="handleSubmitRemind('CampHome')">知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TrainModel from './trainEvaluationModel.vue'
import {getTrainingList, getRemind, postRemind} from '@/api/training'
import {debounce} from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'

const UserProfile = {
  data() {
    return {
      active: '1',
      check: '',
      postListArr: [],
      pageObj: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      },
      showCourseEvaluate: false,
      isNone: false,
      isLoading: false,
      showHome: false,
      showOver: false
    }
  },
  components: {TrainModel},
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    let parmas = {
      userId: this.userInfo.id,
      readType: 'CampHome'
    }
    getRemind(parmas).then(res => {
      this.showHome = !res.data
    })
    let params1 = {
      userId: this.userInfo.id,
      readType: 'CampEndList'
    }
    getRemind(params1).then(res => {
      this.showOver = !res.data
    })
  },
  methods: {
    handleSubmitRemind(type) {
      // CampHome/训练营功能首页谈弹窗提醒;
      // CampEndList/训练营结营列表提醒
      let params = {
        'readType': type,
        'readTypeName': type === 'CampHome' ? '训练营功能首页谈弹窗提醒' : '训练营结营列表提醒',
        'iepUserId': this.userInfo.id
      }
      postRemind(params).then(res => {
        if (`${res.code}` === '0') {
          if (type === 'CampHome') {
            this.showHome = false
          } else {
            this.showOver = false
          }
        }
      })
    },
    handleClick: debounce(function (active) {
      sessionStorage.removeItem('clickActive')
      if (this.active === active) return
      if (active === 'isCommend') {
        active = '3'
      }
      this.active = active
      this.postListArr = []
      this.pageObj = {
        pageNo: 1,
        pageSize: 10,
        finished: false,
        loading: false
      }
      this.isLoading = false
      this.isNone = false
      this.handleGetPostList()
    }, 400),
    handleCheck(check) {
      if (this.check === check) return
      this.check = check
      this.postListArr = []
      this.pageObj = {
        pageNo: 1,
        pageSize: 10,
        finished: false,
        loading: false
      }
      this.isNone = false
    },
    handleGetPostList() {
      if (this.isLoading) return
      this.isLoading = true
      if (sessionStorage.getItem('clickActive')) {
        this.active = sessionStorage.getItem('clickActive')
      }
      if (this.active !== '1') {
        this.check = ''
      }
      let params = {
        pageNum: this.pageObj.pageNo,
        pageSize: this.pageObj.pageSize,
        userId: this.userInfo.id,
        campQueryType: this.active,
        unlockMethod: this.check
      }
      getTrainingList(params).then(res => {
        this.$toast.clear()
        if (res) {
          if (res.code !== 0 || !res.data || !res.data.list) {
            this.pageObj.loading = false
            this.pageObj.finished = true
            return false
          }
          res.data.list.map((item) => {
            item.startTimeTxt = new Date().getTime() > item.startTime ? '' : this.$moment(item.startTime * 1).format('MM月DD日')
            const day = Math.floor(Math.abs(item.timeDifference) / 1000 / 60 / 60 / 24)
            const hours = Math.floor((Math.abs(item.timeDifference) - day * 1000 * 60 * 60 * 24) / 1000 / 60 / 60)
            const minute = Math.floor((Math.abs(item.timeDifference) - day * 1000 * 60 * 60 * 24 - hours * 1000 * 60 * 60) / 1000 / 60)
            const seconds = Math.floor((Math.abs(item.timeDifference) - day * 1000 * 60 * 60 * 24 - hours * 1000 * 60 * 60 - minute * 1000 * 60) / 1000)
            item.startTimeSignTxt = item.timeDifference < 0 ? '' : day > 0 ? `${day}天${hours}小时` : hours > 0 ? `${hours}小时${minute}分钟` : `${minute}分钟${seconds}秒钟`
            if (item.feedbackInfo) {
              item.feedbackInfo.score = item.feedbackInfo.score / 2
            }
            item.startTimeTxt2 = this.$moment(item.startTime * 1).format('YYYY-MM-DD HH:mm:ss')
            item.endTimeTxt2 = this.$moment(item.endTime * 1).format('YYYY-MM-DD HH:mm:ss')
          })
          this.pageObj.loading = false
          if (res.data.list.length < this.pageObj.pageSize) {
            this.pageObj.finished = true
          }
          if (res.code === 0 && res.data.list) {
            this.postListArr = this.postListArr.concat(res.data.list)
          }
          this.pageObj.pageNo++
          this.isNone = this.postListArr.length === 0
        }
        this.isLoading = false
      }).catch(() => {
        this.$toast.clear()
        this.isLoading = false
      })
    },
    handleClickTO(item) {
      sessionStorage.setItem('clickActive', this.active)
      if (this.active === '3') {
        if (!item.joinSign) {
          this.$router.push({
            path: 'trainingDetail',
            query: {
              campId: item.id,
            }
          })
        } else {
          this.$router.push({
            path: 'trainEvaluate',
            query: {
              campMainId: item.campMainId,
              campId: item.id,
            }
          })
        }
      } else if (this.active === '2') {
        this.$router.push({
          path: 'trainCourse',
          query: {
            campId: item.id,
          }
        })
      } else {
        this.$router.push({
          path: 'trainingDetail',
          query: {
            campId: item.id,
          }
        })
      }
    },
    handleClickToCover(item) {
      sessionStorage.setItem('clickActive', this.active)
      if (this.active === '3') {
        // 已结营的没加入过, 去加入
        if (!item.joinSign) {
          this.$router.push({
            path: 'trainingDetail',
            query: {
              campId: item.id,
            }
          })
        } else { // 加入过直接看课程列表
          this.$router.push({
            path: 'trainCourse',
            query: {
              campMainId: item.campMainId,
              campId: item.id,
            }
          })
        }
      } else {
        this.handleClickTO(item)
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.zone {
  padding: 50px 16px 16px;
  box-sizing: border-box;
  min-height: 100vh;
  background: #F9F8F7;
  position: relative;

  .zone-top {
    padding: 12px 16px;
    box-sizing: border-box;
    background: #F9F8F7;
    width: 100%;
    height: 50px;
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
  }

  .flex-nav {
    width: 100%;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .nav-txt {
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      padding: 0 30px;
      box-sizing: border-box;
      position: relative;
      height: 42px;
      line-height: 42px;
      white-space: nowrap;

      .icon1 {
        width: 24px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 6px;
      }

      &.cur {
        color: #EB1700;
        font-weight: 600;
      }
    }
  }

  .list {
    width: 100%;
    background: #ffffff;
    border-radius: 10px;
    padding: 12px 10px;
    box-sizing: border-box;
    &.patop {
      padding-top: 48px;
    }

    .search_box {
      display: flex;
      flex-direction: row-reverse;
      border-radius: 10px;
      position: fixed;
      width: calc(100vw - 32px);
      top: 50px;
      left: 16px;
      padding-top: 12px;
      padding-right: 10px;
      box-sizing: border-box;
      background-color: #fff;
      z-index: 9;

      .search_group {
        width: 121px;
        height: 22px;
        background: #f2f7fa;
        border-radius: 25px 25px 25px 25px;
        display: flex;
        padding: 1px;
        box-sizing: border-box;
        margin-bottom: 12px;

        .btn {
          width: 40px;
          height: 20px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          text-align: center;
          border-radius: 25px;
          line-height: 20px;
        }

        .check {
          background-color: #ffffff;
          color: #EB1700;
        }
      }
    }

    .item {
      margin-bottom: 16px;

      .item_content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;

        .info {
          min-height: 68px;

          .name {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            margin-bottom: 4px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 218px;
          }

          .tips {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #7a8494;
            margin-bottom: 6px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 218px;

            &.tips2 {
              font-size: 12px;
              margin-top: 4px;
            }
          }

          .lock {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #EB1700;
            display: flex;
            align-items: center;

            .img {
              width: 12px;
              height: 13px;
              margin-right: 3px;
              display: block;
            }
          }

          .rate {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #7a8494;
          }
        }

        .img_page {
          min-width: 103px;
          width: 103px;
          height: 68px;
          position: relative;
          border-radius: 5px;
          overflow: hidden;

          .img-txt {
            position: absolute;
            width: 100%;
            height: 22px;
            line-height: 22px;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.3);
            color: #fff;
            bottom: 0;
            left: 0;
            font-size: 13px;
          }

          .img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            display: block;
            border-radius: 5px 5px 5px 5px;
          }
        }
      }

      .item_btn_group {
        width: 100%;
        display: flex;
        align-items: center;

        .item_btn {
          flex: 1;
          width: auto;
        }

        .item_btn + .item_btn {
          margin-left: 10px;
        }
      }

      .item_btn {
        width: 100%;
        height: 36px;
        background: #EB1700;
        border-radius: 30px;
        line-height: 36px;
        text-align: center;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #fff;

        &.item_btn_light {
          background: #FFF4F2;
          color: #EB1700;
          border: 1px solid #EB1700;
          box-sizing: border-box;
        }

        &.isEnd {
          background: rgb(241, 239, 237);
          color: rgb(129, 118, 111);
        }
      }
    }
  }

  .div-infos {
    border-radius: 8px;
    background: rgb(249, 248, 247);
    padding: 10px 10px 26px;
    box-sizing: border-box;
    display: flex;
    position: relative;
    margin-bottom: 15px;

    .icon-tips {
      width: 14px;
      height: 14px;
      display: block;
      margin-right: 4px;
      position: relative;
      top: 3px;
    }

    .infos-txt {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 20px;

      .txt-col {
        color: #EB1700;
      }
    }

    .div-close {
      position: absolute;
      width: 100%;
      bottom: 6px;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #EB1700;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 14px;
      padding-right: 10px;
      box-sizing: border-box;
      z-index: 9;

      .icon-close {
        display: block;
        width: 8px;
        margin-left: 4px;
      }
    }
  }
}

.empty-block {
  padding-top: 114px;
  box-sizing: border-box;

  .empty-img {
    width: 185px;
    display: block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }

  .empty-txt {
    text-align: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .btn-tips {
      color: #FFF;
      width: 101px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #EB1700;
      border-radius: 29px;
      margin-top: 10px;
    }
  }
}

.div-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999;

  .div-mask-bg {
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .div-mask-con {
    width: 322px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    overflow: hidden;
    padding: 17px 25px;
    box-sizing: border-box;

    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 24px;
      margin-bottom: 17px;

      .title-txt {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 17px;
        color: #000000;
        position: relative;
      }
    }

    .content {
      font-family: Source Han Sans CN, Source Han Sans CN;
      color: #000000;
      font-size: 14px;
      line-height: 24px;

      .txt-col {
        color: #EB1700;
      }
    }

    .mask-submit-btn {
      margin-top: 20px;
      width: 240px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      border-radius: 100px;
      background: #EB1700;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #fff;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/list.vue